/**
 * Opens the iubenda cookie preferences from any link pointing to "#cookie-settings"
 * (e.g. a footer menu item), replacing iubenda's floating privacy widget.
 */
(function() {
  const HASH = '#cookie-settings';

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest(`a[href$="${HASH}"]`);
    if (!link) return;

    const api = window._iub?.cs?.api;
    if (!api?.openPreferences) return;

    event.preventDefault();
    api.openPreferences();
  });
})();
